import { render, staticRenderFns } from "./ServiceManualDetail.vue?vue&type=template&id=22e4e144&scoped=true&"
import script from "./ServiceManualDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceManualDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServiceManualDetail.vue?vue&type=style&index=0&id=22e4e144&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e4e144",
  null
  
)

export default component.exports